import type React from 'react';

interface ChatPlusIconProps {
    width?: number;
    height?: number;
    color?: string;
}

/**
 * Speech bubble with a plus — "start a new conversation".
 *
 * Deliberately not a circular arrow: that glyph is Material's `restore`, which
 * reads as undo/revert, and it is why the previous reset control was pulled.
 */
const ChatPlusIcon: React.FC<ChatPlusIconProps> = ({
    width = 16,
    height = 16,
    color = '#656565',
}) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
    >
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        <path d="M12 7v6" />
        <path d="M9 10h6" />
    </svg>
);

export default ChatPlusIcon;
